import { useMergeRefs } from '@floating-ui/react'

import { PdfViewerSelectionAreaBox } from '../../PdfViewer'
import { useDocFlowMappingContext } from '../DocFlow.hooks'
import { DocFlowSelectedAreaInfo } from '../DocFlowSelectedAreaInfo'

function DocFlowPdfSelectArea() {
  const {
    isOpenSelectAreaInfo,
    isPdfFinishedRendering,
    isPdfSelectAreaInfoValueLoading,
    selectAreaBoxProps,
  } = useDocFlowMappingContext()

  const {
    floatingStyles,
    getFloatingProps,
    infoItems,
    refs,
    selectBoxAreaDisabled,
    selectBoxRef,
    ...restSelectAreaBoxProps
  } = selectAreaBoxProps

  return (
    <>
      <PdfViewerSelectionAreaBox
        {...restSelectAreaBoxProps}
        disabled={selectBoxAreaDisabled}
        selectBoxRef={useMergeRefs([refs.setReference, selectBoxRef])}
      />
      <DocFlowSelectedAreaInfo
        floatingStyles={floatingStyles}
        getFloatingProps={getFloatingProps}
        infoItems={infoItems}
        isOpen={isOpenSelectAreaInfo}
        isPdfFinishedRendering={isPdfFinishedRendering}
        loading={isPdfSelectAreaInfoValueLoading}
        refs={refs}
      />
    </>
  )
}

export default DocFlowPdfSelectArea
